import { render, staticRenderFns } from "./ImgSideBar.vue?vue&type=template&id=3a311eb5&v-slot%3Adefault=true&"
import script from "./ImgSideBar.vue?vue&type=script&lang=js&"
export * from "./ImgSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ImgSideBar.vue?vue&type=style&index=0&id=3a311eb5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports